import { render } from "./PrestamoCreate.vue?vue&type=template&id=40389a7e&scoped=true"
import script from "./PrestamoCreate.vue?vue&type=script&lang=js"
export * from "./PrestamoCreate.vue?vue&type=script&lang=js"

import "./PrestamoCreate.vue?vue&type=style&index=0&id=40389a7e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40389a7e"]])

export default __exports__